import React from 'react';

const BuyButton = ({label, articleNumber, quantityFieldId, href, cssClass, onClick, disabled}) => {

    const disabledCssClass = disabled ? " disabled" : "";
    cssClass += disabledCssClass;
    return (
            articleNumber ?
            <button className={cssClass} onClick={() => onClick(articleNumber, quantityFieldId)}>
                {label}
            </button>
            : <a href={href}>
            {label} 
        </a>
    )
}

export default BuyButton;
